import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BulkActions = ({ selectedCount, onClearSelection, onSendMessage }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 w-full max-w-2xl px-4">
      <div className="card bg-primary text-primary-foreground shadow-warm-xl">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary-foreground/20 flex items-center justify-center">
              <Icon name="Users" size={20} color="var(--color-primary-foreground)" />
            </div>
            <div>
              <p className="font-semibold text-sm md:text-base">
                {selectedCount} {selectedCount === 1 ? 'Member' : 'Members'} Selected
              </p>
              <p className="text-xs opacity-80">
                Ready for bulk actions
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={onSendMessage}
              iconName="MessageSquare"
              iconPosition="left"
              className="bg-primary-foreground/20 hover:bg-primary-foreground/30 text-primary-foreground"
            >
              <span className="hidden sm:inline">Message</span>
            </Button>
            
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearSelection}
              iconName="X"
              className="bg-primary-foreground/20 hover:bg-primary-foreground/30 text-primary-foreground"
            >
              <span className="hidden sm:inline">Clear</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActions;